import React, { useState, useEffect, Fragment } from 'react';
import { Button, Dialog, Box, makeStyles, DialogTitle, DialogContent, Chip } from '@material-ui/core';
import { useDropzone } from 'react-dropzone';

const addStyle = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: theme.palette.common.dark,
    },
  },
  num: {
    display: 'block',
    width: '100%',
  },
  file: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'block',
    marginLeft: '10px',
    textOverflow: 'ellipsis',
    maxWidth: '150px',
  },
}));

const defaultReclamo = {
  num: '',
  fechaIngreso: '',
  tipo: '',
  reclamante: '',
  Rut: '',
  Etapa: '',
  materia: '',
  via: '',
  region: '',
  comuna: '',
};

const AddRecurso = ({ openDialog = false, close, reclamo = defaultReclamo }) => {
  const classes = addStyle();
  const [num, setNum] = useState('');
  const [file, setFile] = useState(null);
  const { /*  acceptedFiles, */ getRootProps, getInputProps } = useDropzone({
    accept: 'image/*, applications/pdf',
    onDrop: acceptedFiles => {
      if (acceptedFiles.length) {
        setFile(acceptedFiles[0]);
      } else {
        setFile(null);
      }
    },
  });

  useEffect(() => {
    if (reclamo) {
      setNum(reclamo.n_reclamo ? reclamo.n_reclamo : 'nulo');
    }
  }, [reclamo]);

  const prueba = () => {};

  const onCloseDialog = event => {
    setFile(null);
    close();
  };

  const FileChip = () => {
    return file ? `${file.path} - ${Math.ceil((file.size * 10) / 1024) / 10} KB` : '';
  };

  return (
    <Dialog open={openDialog} onClose={onCloseDialog}>
      <DialogTitle className={classes.dialogTitleRoot}>
        <label className={classes.num}> Añadir Recurso a Reclamo N° {num} </label>
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'column' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
          <section className="container">
            <div {...getRootProps({ className: 'dropzone' })}>
              <input {...getInputProps()} />
              <p>Subir un documento</p>
              <em>(Solo archivos de imagen o pdf)</em>
            </div>
            <aside>
              {file !== null && (
                <Fragment>
                  <h4>Archivo:</h4>
                  <Chip key={'Chip-Archivo'} label={FileChip()} />
                </Fragment>
              )}
            </aside>
          </section>
        </Box>
        <Box display="flex" justifyContent="flex-end" mb={4}>
          <Button onClick={onCloseDialog}>&nbsp;Cerrar&nbsp;</Button>
          <Button onClick={prueba}>&nbsp;Subir&nbsp;</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AddRecurso;
